import { ASSETS_BASE_URL, DEFAULT_LAYOUT } from "../config";
import { ROUTES } from "../constants";

const baseImage = `${ASSETS_BASE_URL}/stock.png`;

const buildPage = (page) => ({
  category: "Pages",
  sub_name: "",
  image: baseImage,
  ...page,
});

const sharedPages = [
  { name: "Home", href: ROUTES.HOME_ALIAS || ROUTES.HOME },
  { name: "Machines", href: ROUTES.MACHINES, searchTerms: ["My Machines"] },
  { name: "Order History", href: ROUTES.ORDER_HISTORY, searchTerms: ["Buy Again", "Buyagain"] },
  { name: "Track Order", href: ROUTES.TRACK_ORDER },
  { name: "Cart", href: ROUTES.CART },
  { name: "Profile", href: ROUTES.PROFILE },
  { name: "Settings", href: ROUTES.SETTINGS },
  { name: "Admin", href: ROUTES.ADMIN },
  { name: "Recommended Spare Parts List", href: ROUTES.RSPL, searchTerms: ["RSPL"] },
  { name: "Recommendations", href: ROUTES.RECOMMENDATIONS, searchTerms: ["My Lists", "My List", "Lists"] },
  { name: "Requests", href: ROUTES.REQUESTS, searchTerms: ["CCR", "Customer Care Requests"] },
  { name: "Saved For Later", href: ROUTES.SAVED_FOR_LATER },
  { name: "Documents", href: ROUTES.DOCUMENT },
  { name: "Support", href: ROUTES.SUPPORT, searchTerms: ["CCR Support", "Customer Care"] },
  { name: "Order Analytics", href: ROUTES.ANALYTICS },
  { name: "User Analytics", href: ROUTES.USER_ANALYTICS },
  { name: "Notifications", href: ROUTES.NOTIFICATIONS },
  { name: "Search Results", href: ROUTES.SEARCH_RESULTS },
];

const layout2Pages = [
  { name: "Parts", href: "/parts" },
  { name: "Service", href: "/service" },
  { name: "Training", href: "/training" },
  { name: "Digital Solutions", href: "/service/digital-solutions" },
  { name: "Preventive Dashboard", href: "/service/digital-solutions/preventive-dashboard" },
  { name: "Predictive Dashboard", href: "/service/digital-solutions/predictive-dashboard" },
  { name: "Sustainable Oven Service Dashboard", href: "/service/digital-solutions/sustainable-oven-service-dashboard" },
  { name: "Machine Dashboard", href: "/service/digital-solutions/machine-dashboard" },
  { name: "Cases (Tickets)", href: "/service/cases" },
  { name: "Work Orders & Reports", href: "/service/workorders" },
];

const layout2Active = (DEFAULT_LAYOUT || "").toLowerCase() === "layout2";

const pageRoutes = [
  ...sharedPages,
  ...(layout2Active ? layout2Pages : []),
].map(buildPage);

export default pageRoutes;
